var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CoreConfig } from '../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { ChipsView } from '../Common/ChipsView';
export const InfoButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.infoButton,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign({ minHeight: 46, borderRadius: 8 }, props.containerStyle),
            image: Object.assign({ width: 25, height: 25, borderRadius: 0 }, props.imageContainerStyle),
            text: Object.assign({}, props.textStyle)
        };
    }
})((_a) => {
    var { style } = _a, props = __rest(_a, ["style"]);
    return (_jsx(ChipsView, Object.assign({}, props, { containerStyle: style === null || style === void 0 ? void 0 : style.container, imageContainerStyle: style === null || style === void 0 ? void 0 : style.image, textStyle: style === null || style === void 0 ? void 0 : style.text })));
});
